/**
 * Handle Nav Dropdown
 */
const handleNavDropdown = () => {
	const $trigger = $('.has-dropdown');
	const tabletBreakpoint = 1023;

	$trigger.on('click', '> a', function(event) {
		if ($(window).innerWidth() <= tabletBreakpoint) {
			const $this = $(this);
			const $dropdownParent = $this.closest('li');
			const $dropdownContainer = $dropdownParent.find('.nav__dropdown');

			$dropdownParent.toggleClass('is-active');

			$dropdownContainer.slideToggle();

			event.preventDefault();
		}
	});
}

handleNavDropdown();
